export class OrderCategoryItem {
    public CategoryId: number;
    public ItemId: number;
}
